"use client";
import { Box, Stack } from "@mui/material";

import { useStore, observer } from "../../../../../../../service/mobx";
import Section from "./Section";

const Content = observer(function Content({ tab }) {
  const { reader } = useStore();

  return (
    <Stack width="100%">
      {reader.relatedContentFiltered.map(([title, items, cardType, url]) => (
        <Section
          key={title}
          tab={tab}
          url={url}
          title={title}
          items={items}
          cardType={cardType}
        />
      ))}
    </Stack>
  );
});
export default Content;
export const ContentSwitch = observer(function ContentSwitch({ article, tab }) {
  const { device, reader } = useStore();

  if (device.isDesktop === false && tab !== "paper") {
    const section = reader.relatedContentFiltered.filter(
      content => content[3] === tab
    );

    return (
      <Box px={1} pt={4} pb={8}>
        {section.map(([title, items, cardType, url]) => (
          <Section
            showAll
            url={url}
            tab={tab}
            key={title}
            title={title}
            items={items}
            cardType={cardType}
          />
        ))}
      </Box>
    );
  } else {
    return article;
  }
});
